import { useEffect, useState } from 'react'

/**
 * Returns true when the visitor asked the OS to reduce motion.
 * Starts as false on the server and on first render, then reads the
 * real preference after mount so server and client markup always match.
 */
export const useReducedMotion = (): boolean => {
    const [reduced, setReduced] = useState(false)

    useEffect(() => {
        const query = window.matchMedia('(prefers-reduced-motion: reduce)')
        const update = () => setReduced(query.matches)

        update()
        query.addEventListener('change', update)

        return () => query.removeEventListener('change', update)
    }, [])

    return reduced
}
